module.exports = __webpack_public_path__ + "static/media/fb-white.37265d56.svg";